import { PUBLIC_URL } from "@/lib/publicUrl";
import { useState } from "react";
import { waBusinessHref, openWaBusiness } from "@/lib/whatsapp";
import { Share2, Link2, Check } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const WhatsAppIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.6c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.1c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4zM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2z" /></svg>
);

export const ShareDesign = ({ design }) => {
  const [copied, setCopied] = useState(false);
  const url = `${PUBLIC_URL}/catalog/${design.design_id}`;
  const text = `Check out "${design.title}" from All-Ways Graphic — from $${Number(design.base_price || 0).toFixed(2)} per print. ${url}`;
  const wa = waBusinessHref(null, text);
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); toast.success("Link copied"); setTimeout(() => setCopied(false), 2000); } catch { toast.error("Couldn't copy — long-press the address bar instead"); }
  };
  const native = async () => {
    if (!navigator.share) return copy();
    try { await navigator.share({ title: design.title, text, url }); } catch { /* user cancelled */ }
  };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-design">
      <a href={wa} onClick={(e) => { e.preventDefault(); openWaBusiness(null, text); }} rel="noopener noreferrer" data-testid="share-whatsapp-btn"
        className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full bg-[#25D366]/15 border border-[#25D366]/40 text-[#25D366] hover:bg-[#25D366]/25 text-sm font-semibold transition-colors">
        <WhatsAppIcon />Share on WhatsApp
      </a>
      <Button type="button" variant="outline" onClick={copy} data-testid="share-copy-btn" className="h-9 rounded-full border-zinc-700 bg-transparent text-zinc-200 hover:bg-zinc-800 text-sm font-semibold">
        {copied ? <Check size={14} className="mr-1.5 text-[#10b981]" /> : <Link2 size={14} className="mr-1.5" />}{copied ? "Copied" : "Copy link"}
      </Button>
      {typeof navigator !== "undefined" && navigator.share && (
        <Button type="button" variant="outline" onClick={native} data-testid="share-native-btn" className="h-9 w-9 p-0 rounded-full border-zinc-700 bg-transparent text-zinc-200 hover:bg-zinc-800" aria-label="More share options"><Share2 size={14} /></Button>
      )}
    </div>
  );
};
